import React from "react";
import { useState } from "react";

import { Typography, Button } from "@mui/material";

const StepOneForm = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);

  return (
    <React.Fragment>
      <Typography variant="h4" sx={{ mt: "3rem", mb: 1, fontWeight: "bold" }}>
        10 MINUTES TO GO FROM 0 TO 100
      </Typography>
      <Typography variant="body1">
        Are you ready to get onboarded onto SG’s fastest growing community of
        action-taking founders?
      </Typography>
      <Button
        color="primary"
        variant="contained"
        fullWidth
        type="submit"
        sx={{ mt: "1rem" }}
        onClick={props.handleNext}
      >
        I'm ready
      </Button>
    </React.Fragment>
  );
};

export default StepOneForm;
